(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerBlackout',
	};

    $(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		Adzuki.CustomConfirm({
			body   : response.data.message,
			confirm: function onConfirm() {
				$('#liveplannerblackout-confirm').val('1');
				$(form.element).submit();
			},
			cancel: function onCancel() {
				$('#liveplannerblackout-confirm').val('0');
			}
		});
	};
}(jQuery, window.Adzuki || {}));